<template>
  <div>
    <van-popup v-model="show" position="bottom" class="rect" @close="onClose" @opened="onOpened">
      <div class="title">
        <div class="titleLine">
          <van-row>
            <van-col span="2" />
            <van-col span="20" class="center">客服咨询</van-col>
            <van-col span="2" class="textRight"><i class="iconfont iconclosex rightGoto" @click="onClose" /></van-col>
          </van-row>
        </div>
      </div>
      <div id="mainRect" class="mainRect">
        <div class="emptyRectTop" />
        <p v-if="finished" class="center aboutStr pagebody">没有更多数据了</p>
        <p v-if="loading" class="center aboutStr pagebody">读取数据中</p>

        <div v-for="item in list" :key="item.id" class="line">
          <van-row v-if="item.isAsk" class="line">
            <van-col span="16" offset="4">
              <div class="time textRight">{{ DialogDate(item.createTime) }}</div>
              <div class="talk rigth">
                {{ item.body }}
              </div>
            </van-col>
            <van-col span="3" offset="1">
              <van-image
                width="3em"
                height="3em"
                fit="cover"
                :src="item.icon"
              />
              <!-- <img :src="item.icon" class="icon"> -->
            </van-col>
          </van-row>

          <van-row v-if="!item.isAsk" class="line">
            <van-col span="3">
              <van-image
                width="3em"
                height="3em"
                fit="cover"
                :src="item.icon"
              />
            </van-col>
            <van-col span="16" offset="1">
              <div class="time">{{ DialogDate(item.createTime) }}</div>
              <div class="talk">
                {{ item.body }}
              </div>
            </van-col>
          </van-row>

        </div>
        <div class="emptyRectBottom" />
      </div>
      <!-- <div v-show="false" style="padding:0 0.5em;">
        <van-row class="line">
          <van-col span="16" offset="4">
            <div class="time textRight">10分钟前</div>
            <div class="talk rigth">
              <van-image
                width="8em"
                height="8em"
                fit="cover"
                src="http://kohtao.cn/pcimg/news_top1.jpg"
                @click="onPreview('http://kohtao.cn/pcimg/news_top1.jpg')"
              />
            </div>
          </van-col>
          <van-col span="3" offset="1">
            <img src="https://my.divessi.com/data/Image/facility_logos/786016.png" class="icon">
          </van-col>
        </van-row>
      </div> -->

      <div class="inputRect">
        <van-row>
          <van-col span="20"><van-field v-model="inputText" placeholder="请输入想要咨询的内容" /></van-col>
          <van-col span="4">
            <van-button v-if="inputText.length==0" :loading="sending" plain style="width:100%" type="info" @click="onSendImg">发送</van-button>
            <van-button v-if="inputText.length!=0" :loading="sending" plain style="width:100%" type="info" @click="onSendText">发送</van-button>
          </van-col>
        </van-row>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Popup, Image, ImagePreview, List, Button, Field } from 'vant'
import { formatDate, MyNotify } from '@/utils/base'
import request from '@/utils/request'
export default {
  components: {
    [Popup.name]: Popup,
    [Image.name]: Image,
    [ImagePreview.name]: ImagePreview,
    [List.name]: List,
    [Field.name]: Field,
    [Button.name]: Button
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    commodityId: {
      default: undefined
    },
    // eslint-disable-next-line vue/require-prop-types
    shopId: {
      default: undefined
    },
    value: Boolean
  },
  data() {
    return {
      selectId: this.select,
      show: false,
      list: [],
      loading: false,
      finished: false,
      inputText: '',
      sending: false,
      timerReload: undefined,
      search: {
        limit: 30,
        page: 1,
        shopId: undefined
      }

    }
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue) {
        this.show = true
      }
    }
  },
  created() {
  },
  methods: {
    formatDate,
    handleScroll() {
      var scrollTop = document.getElementById('mainRect').scrollTop
      // console.log('滚动了', scrollTop)
      if (scrollTop < 100) {
        if (this.finished) {
          this.loading = false
          return
        }
        if (this.loading) {
          return
        }

        this.onLoad(false)
      }
    },
    onOpened() {
      document.getElementById('mainRect').addEventListener('scroll', this.handleScroll)
      this.onLoad(true)
      this.timerReload = setInterval(this.onReloadChat, 1000 * 1000)
    },
    onClose() {
      this.show = false
      this.$emit('input', false)
      clearInterval(this.timerReload)
    },
    gotoEnd() {
      console.log('跳转到末尾')
      this.$nextTick(() => {
        var div = document.getElementById('mainRect')
        div.scrollTop = div.scrollHeight
      })
    },
    DialogDate(date) {
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss', true)
    },

    onPreview(imageUrl) {
      ImagePreview({
        images: [imageUrl],
        showIndex: false,
        minZoom: 1
      })
    },
    onSendImg() {
      MyNotify('error', '请输入想要咨询的内容')
    },
    onSendText() {
      this.sending = true
      request({
        url: '/Store/addDialogue',
        method: 'post',
        data: {
          type: 'TEXT',
          shopId: this.shopId,
          isAsk: true,
          body: this.inputText
        }
      }).then(response => {
        this.sending = false
        if (!response.success) {
          this.error = true
          return
        }
        this.inputText = ''
        this.list.push(response.data)
        this.gotoEnd()
      })
    },
    onLoad(isFirst) {
      this.search.shopId = this.shopId
      this.loading = true
      request({
        url: '/Store/getShopDialogueList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        // reverse().反转
        response.data.rows.forEach(item => {
          this.list.unshift(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
        if (isFirst) {
          this.gotoEnd()
        }
      })
    },
    onReloadChat() {
      if (this.loading) {
        return
      }
      var maxId = 0
      this.list.map((value, index, array) => {
        if (parseInt(value.id) > maxId) {
          maxId = parseInt(value.id)
        }
      })
      console.log('刷新数据中', maxId)
      request({
        url: '/Store/getNewShopDialogue',
        method: 'post',
        data: {
          shopId: this.shopId,
          id: maxId
        }
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        console.log('刷新数据', response.data)
        response.data.reverse().forEach(item => {
          this.list.push(item)
        })
        if (response.data.length > 0) {
          this.gotoEnd()
        }
      })
    }
  }
}
</script>
<style scoped>
.rect{
  height: 80%;
  border-top-left-radius: 0.8em;
  border-top-right-radius: 0.8em;
  background-color: #F1F1F1;
}
.rect .title{
  position: fixed;
  top: 20%;
  left: 0;
  width: 100%;
  border-bottom: 1px solid #cacaca;
  background-color: #fff;
  z-index: 2;
}
.rect .title .titleLine{
  padding: 0.6em;
}
.listBody{
  padding:0 0.5em;
  height: 100%;
}
.line{
  margin-bottom: 0.6em;
  padding: 0 0.3em;
}
.line .talk{
  padding: 0.2em;
  background-color: #fff;
  border: 1px solid #eaeaea;
  border-radius: 0.2em;
  width:fit-content;
  max-width: 100%;
  z-index: 2;
}
.line .rigth{
  float: right;
}
.line .time{
  margin-bottom: 0.2em;
  font-size: 10px;
  color: #999;
}
.inputRect{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}
.mainRect{
  width: 100%;
  height:  100%;
  overflow-y: auto;
}

.emptyRectTop{
  height: 2.6em;
}
.emptyRectBottom{
  height: 44px;
}
.mainRect::-webkit-scrollbar {
  width: 4px;
}
.mainRect::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  background: rgba(0,0,0,0.2);
}
.mainRect::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  border-radius: 0;
  background: rgba(0,0,0,0.1);
}
</style>
